import * as React from "react";
const SvgFiRrMarsStrokeUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mars-stroke-up_svg__a)">
      <path
        fill="#062147"
        d="M13 10.08V9h2a1 1 0 1 0 0-2h-2V2.568l2.317 2.163a1 1 0 0 0 1.414-.048 1 1 0 0 0-.049-1.414L14.121.879c-1.17-1.17-3.073-1.17-4.218-.024L7.317 3.269A1 1 0 1 0 8.682 4.73l2.317-2.164V7h-2a1 1 0 1 0 0 2h2v1.08c-3.386.488-6 3.4-6 6.92 0 3.86 3.141 7 7 7s7-3.14 7-7c0-3.52-2.613-6.432-5.999-6.92M12 22c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mars-stroke-up_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMarsStrokeUp;
